import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
  import { useStore } from 'vuex';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MyHeader',
  setup(__props, { expose }) {
  expose();

  const h1Text = ref('Choose tracks');
  const store = useStore();
  
  store.subscribe((mutation, state) => {
    if (mutation.type === 'refreshTrackList') {
      h1Text.value = 'Enjoy music!';
    }
  });

const __returned__ = { h1Text, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})